<template>
  <div class="user-wrap">
    <div class="header-title">用户管理</div>
    <role-user-table @editUserManage="editUserManage"></role-user-table>
    <newuser-modal
      :formVisible="formVisible"
      :ruleFormProps="ruleFormProps"
      @closeDialogForm="closeDialogForm"
      :userId="userId"
      :title="title"
      @reloadTable="reloadTable"
    ></newuser-modal>
  </div>
</template>
<script>
import NewuserModal from "./newUserModal";
import RoleUserTable from "./roleUserTable";
import userServer from "@/api/userManagement.js";
// import SvgIcon from "../../components/SvgIcon.vue";
export default {
  name: "role",
  data() {
    return {
      formVisible: false,
      ruleFormProps: {
        username: "",
        password: "",
        repeatPassword: "",
        name: "",
        dept: "",
        desc: "",
      },
      userId: "",
      loading: true,
      title: "新建用户",
      depList: [],
      curDepId: null,
    };
  },
  computed: {
    list: function () {
      return this.$store.state.RolePower.roleUserList;
    },
  },
  beforeDestroy: function () {
    this.$store.dispatch("getuserCurrentPage", 1);
  },
  mounted: function () {
    // this.getDepartmentList();
    this.queryDataByParmas({
      currentPage: 1,
      pageSize: 10,
    });
    // this.$store.dispatch("getRoleUserList", {
    //   param: { currentPage: 1, pageSize: 10 },
    //   cb: () => {
    //     this.loading = false;
    //   },
    // });
  },
  components: {
    NewuserModal,
    RoleUserTable,
    // SvgIcon,
  },
  methods: {
    getDepartmentList() {
      userServer.getDepartments().then((res) => {
        if (res.code === "0000") {
          this.depList = res.orgTreeUserCountInfos;
          if (this.depList.length > 0) {
            this.curDepId = this.depList[0].org.id;
            this.queryDataByParmas({
              currentPage: 1,
              pageSize: 10,
              orgTreeId: this.curDepId,
            });
          }
        }
      });
    },
    changeDepartment(depId) {
      this.curDepId = depId;
      this.queryDataByParmas({
        currentPage: 1,
        pageSize: 10,
        orgTreeId: this.curDepId,
      });
    },
    handlerButton() {
      this.formVisible = true;
      this.title = "新建用户";
    },
    closeDialogForm() {
      this.ruleFormProps = {
        username: "",
        password: "",
        repeatPassword: "",
        name: "",
        dept: "",
        desc: "",
      };
      this.userId = "";
      this.formVisible = false;
    },
    editUserManage(row) {
      let obj = {
        研发部: "2",
        研发一部: "3",
        研发二部: "4",
        研发三部: "5",
        测试部: "6",
        市场部: "7",
        投放组: "13",
        美术部: "8",
        财务部: "9",
        总经办: "10",
        策划部: "11",
        人事行政部: "12",
      };

      this.formVisible = true;
      this.ruleFormProps.username = row.username;
      this.ruleFormProps.password = row.password;
      this.ruleFormProps.repeatPassword = row.password;
      this.ruleFormProps.name = row.name;
      this.ruleFormProps.dept = obj[row.orgName];
      this.ruleFormProps.desc = row.remark;
      this.userId = row.id.toString();
      this.title = "修改用户";
    },
    showLoading(bool) {
      this.loading = bool;
    },
    reloadTable() {
      this.queryDataByParmas({
        currentPage: this.$store.state.RolePower.userCurrentPage,
        pageSize: 10,
        orgTreeId: this.curDepId,
      });
    },
    queryDataByParmas(parmas) {
      this.$store.dispatch("getRoleUserList", {
        param: parmas,
        cb: () => {
          this.loading = false;
        },
      });
    },
  },
};
</script>
<style lang="less" scoped>
.user-wrap {
  margin: 16px;
  height: calc(100vh - 125px);
  padding: 16px 24px 16px 24px;
  border-radius: 4px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.12);
  .header-title {
    color: rgba(0, 0, 0, 0.85);
    font-weight: bold;
    font-size: 15px;
    flex: 1;
    margin-bottom: 16px;
  }
  .table-item {
    max-width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>